module.exports = __webpack_public_path__ + "img/logo (1).6cebf7f6.svg";